import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, Row, Table } from "antd"
import Column from "antd/lib/table/Column"
import { baseAxiosNoInfo } from "../../../tool/axios"
import { CheckImgs } from "../../../component/common/Imgs"
import UpdatePayRecord from "./UpdatePayRecord"

type fetchParams = {
    pay_id: string
    review_status: string // 审核状态，0待审核 1审核通过 2审核不通过，整数类型
    pay_amount: string // 已收金额，小数类型
    pay_item: string // 收款项目，1合同全款 2合同首付 3一对一陪护 4合同尾款 5医院陪护，整数类型
    pay_way: string // 付款方式，1现金 2支付宝 3微信 4银联卡
    pay_time: string // 付款时间
    deal_sales_name: string // 负责人
    pay_prov_pic_list: string // 付款收据图片集合，英文逗号拼接
}

interface dataType {
    check_in_user_name: string // 入住人名称
    check_in_phone: string // 入住人手机号
    deal_id: string // 签单标识
    deal_date: string // 签单日期
    deal_store_name: string // 签单门店名称
    deal_item_name: string // 签单套餐名称
    agreement_code: string // 合同编号
    item_days: string // 入住天数，整数类型
    gift_days: string // 赠送天数，整数类型
    agreement_amount: string // 合同总金额，小数类型
    total_pay_amount: string // 已收金额，小数类型
    total_review_amount: string // 已审核金额，小数类型
    has_one_to_one: string // 是否专人陪护，0没有 1有，整数类型
    remark: string // 备注
    create_time: string // 记录生成时间
    deal_prov_pic_list: string // 签单合同图片集合，英文逗号拼接
    pay_detail: {
        pay_id: string
        review_status: string // 审核状态，0待审核 1审核通过 2审核不通过，整数类型
        pay_amount: string // 已收金额，小数类型
        pay_item: string // 收款项目，1合同全款 2合同首付 3一对一陪护 4合同尾款 5医院陪护，整数类型
        pay_way: string // 付款方式，1现金 2支付宝 3微信 4银联卡
        pay_time: string // 付款时间
        deal_sales_name: string // 负责人
        pay_prov_pic_list: string // 付款收据图片集合，英文逗号拼接
    }[]
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<dataType[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [payId, setPayId] = useState<string>()
    const [updatePayVisible, setUpdatePayVisible] = useState<boolean>(false)

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/deal_records', {
            params: {
                page,
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 收款记录 */}
        {data.map((el: dataType, index) =>
            <Fragment key={el.deal_id || `item-${index}`}>
                <div className="common-main" style={{ marginTop: '10px' }}>
                    <Row style={{ marginBottom: 8 }}>
                        <Col span={6}>客户名称：{el.check_in_user_name}</Col>
                        <Col span={6}>客户手机号：{el.check_in_phone}</Col>
                    </Row>
                    <Row style={{ marginBottom: 8 }}>
                        <Col span={6}>签单门店：{el.deal_store_name}</Col>
                        <Col span={6}>签单日期：{el.deal_date}</Col>
                        <Col span={6}>签单合同图片：
                            <Button onClick={() => {
                                setUrls(el.deal_prov_pic_list.split(','))
                                setSiperVisible(true)
                            }} size="small" >查看</Button>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 8 }}>
                        <Col span={6}>签单套餐：{el.deal_item_name}</Col>
                        <Col span={6}>套餐天数：{el.item_days}</Col>
                        <Col span={6}>赠送天数：{el.gift_days}</Col>
                    </Row>
                    <Row style={{ marginBottom: 16 }}>
                        <Col span={24}>合同备注：{el.remark}</Col>
                    </Row>
                </div>

                <h5 style={{ fontSize: 18, marginBottom: 8 }}>收款记录</h5>
                <ul style={{ listStyle: 'none', marginTop: 8, paddingTop: 0 }}>
                    <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={el.pay_detail}>
                        <Column title="收款日期" dataIndex="pay_time" />
                        <Column title="收款项目" dataIndex="pay_item" render={(v: number) => {
                            if (v === 1) return '合同全款'
                            if (v === 2) return '合同首付'
                            if (v === 3) return '一对一陪护'
                            if (v === 4) return '合同尾款'
                            if (v === 5) return '医院陪护'
                            if (v === 6) return '月嫂到家'
                            if (v === 7) return '续住'
                            if (v === 8) return '其他'
                            if (v === 9) return '月子餐'
                            if (v === 10) return '入住押金'
                            if (v === 11) return '套餐升级'
                            if (v === 12) return '诚意金'
                        }} />
                        <Column title="收款方式" dataIndex="pay_way" render={(v: number) => {
                            if (v === 1) return '现金'
                            if (v === 2) return '支付宝'
                            if (v === 3) return '微信'
                            if (v === 4) return '银联卡'
                            if (v === 5) return '押金抵扣'
                            if (v === 6) return '小精灵'
                            if (v === 7) return '对公转账'
                            if (v === 8) return '抵扣券'
                        }} />
                        <Column title="收款金额" dataIndex="pay_amount" />
                        <Column title="收款凭证" dataIndex="pay_prov_pic_list" key="pay_prov_pic_list" render={(v: any) => {
                            return <Button onClick={() => {
                                setUrls(v.split(','))
                                setSiperVisible(true)
                            }} size="small" >查看</Button>
                        }} />

                        <Column title="录入人" dataIndex="deal_sales_name" />
                        <Column title="审核结果" dataIndex="review_status" render={(v: number) => {
                            if (v === 0) return '待审核'
                            if (v === 1) return '审核通过'
                            if (v === 2) return '审核不通过'
                        }} />

                        <Column title="操作" dataIndex="update_pay_id" render={(v: string) => {
                            if (v)
                                return <Button type="primary" size="small" onClick={() => {
                                    setPayId(v)
                                    setUpdatePayVisible(true)
                                }}>修改</Button>
                        }} />
                    </Table>
                </ul>
            </Fragment>)}

        {showLoadBtn && <Button onClick={() => {
            setPage(page + 1)
        }}>加载更多数据</Button>}

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
        <UpdatePayRecord payID={payId} visible={updatePayVisible} onCancel={() => { setUpdatePayVisible(false) }} />
    </div>
}